/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DocumentTypeCategoryWithLinks } from '../models/document-type-category-with-links';
@Injectable({
  providedIn: 'root',
})
class DocumentTypeCategoriesWithLinksService extends __BaseService {
  static readonly DocumentTypeCategoriesWithLinksGetPath = '/document-type-categories-with-links/{documentTypeCategoryId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the document type category with links
   * @param params The `DocumentTypeCategoriesWithLinksService.DocumentTypeCategoriesWithLinksGetParams` containing the following parameters:
   *
   * - `documentTypeCategoryId`: GUID of the document type category
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  DocumentTypeCategoriesWithLinksGetResponse(params: DocumentTypeCategoriesWithLinksService.DocumentTypeCategoriesWithLinksGetParams): __Observable<__StrictHttpResponse<DocumentTypeCategoryWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/document-type-categories-with-links/${encodeURIComponent(String(params.documentTypeCategoryId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DocumentTypeCategoryWithLinks>;
      })
    );
  }
  /**
   * Returns the document type category with links
   * @param params The `DocumentTypeCategoriesWithLinksService.DocumentTypeCategoriesWithLinksGetParams` containing the following parameters:
   *
   * - `documentTypeCategoryId`: GUID of the document type category
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  DocumentTypeCategoriesWithLinksGet(params: DocumentTypeCategoriesWithLinksService.DocumentTypeCategoriesWithLinksGetParams): __Observable<DocumentTypeCategoryWithLinks> {
    return this.DocumentTypeCategoriesWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as DocumentTypeCategoryWithLinks)
    );
  }
}

namespace DocumentTypeCategoriesWithLinksService {

  /**
   * Parameters for DocumentTypeCategoriesWithLinksGet
   */
  export interface DocumentTypeCategoriesWithLinksGetParams {

    /**
     * GUID of the document type category
     */
    documentTypeCategoryId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { DocumentTypeCategoriesWithLinksService }